export enum ImgixFitType {
  CLAMP = 'clamp',
  CROP = 'crop',
  FACEAREA = 'facearea',
}
